import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAllTrainingsCompleted = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4537 3.0625C11.8359 3.0625 12.9567 4.18332 12.9567 5.56554V11.4972C12.9567 12.8794 11.8359 14.0003 10.4537 14.0003H5.54747C4.16525 14.0003 3.04443 12.8794 3.04443 11.4972V5.56554C3.04443 4.18332 4.16525 3.0625 5.54747 3.0625M6.02751 8.89407L7.32216 10.1887L9.97176 7.53907M9.54903 4.19041H6.45122C5.95177 4.19041 5.54703 3.78566 5.54703 3.28622V2.90418C5.54703 2.40474 5.95177 2 6.45122 2H9.54903C10.0485 2 10.4532 2.40474 10.4532 2.90418V3.28622C10.4532 3.78566 10.0485 4.19041 9.54903 4.19041Z",
		stroke: "#596180",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAllTrainingsCompleted;
